module.exports = __webpack_public_path__ + "3bdf425d55ee55fb02377d8c60613bf2.pdf";